// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3K-Ma","notes":"Notes_notes__30j5U"};